import styled from '@emotion/styled'
import Form from 'antd/lib/form'

export const StyledFormItem = styled(Form.Item)`
  .ant-input-textarea-show-count::after {
    position: relative;
    top: 6px;

    color: #4a4a68;
    font-size: 11px;
  }
`
